export class NumericInputHelperUtil {
  public static readonly handleKeydown = (ev: KeyboardEvent): void => {
    const { code } = ev;
    const allowedCodes = [
      '',
      'Comma',
      'Period',
      'ArrowLeft',
      'ArrowRight',
      'Backspace',
      'Delete',
      'Digit1',
      'Digit2',
      'Digit3',
      'Digit4',
      'Digit5',
      'Digit6',
      'Digit7',
      'Digit8',
      'Digit9',
      'Digit0',
      'Digit1',
      'Numpad0',
      'Numpad1',
      'Numpad2',
      'Numpad3',
      'Numpad4',
      'Numpad5',
      'Numpad6',
      'Numpad7',
      'Numpad8',
      'Numpad9',
      'NumpadComma',
      'NumpadDecimal',
      'MetaLeft',
      'ControlRight',
      'ControlLeft',
      'KeyV',
    ];
    const isValidCode = allowedCodes.includes(code);
    if (!isValidCode) {
      ev.preventDefault();
    }
  };

  public static readonly handleWheel = (ev: Event): void => {
    ev.preventDefault();
  };
}
